/** Extra hub subcategory labels for ja/zh-CN/zh-TW/hi/th/id. Missing keys fall back to English. */

const L = (ja, zhCN, zhTW, hi, th, id) => ({
  ja, 'zh-CN': zhCN, 'zh-TW': zhTW, hi, th, id,
});

export const HUB_SUB_LABEL_BY_EN = {
  Korean: L('韓国料理', '韩餐', '韓餐', 'कोरियाई', 'เกาหลี', 'Korea'),
  Japanese: L('日本料理', '日料', '日料', 'जापानी', 'ญี่ปุ่น', 'Jepang'),
  Western: L('洋食', '西餐', '西餐', 'पश्चिमी', 'อาหารตะวันตก', 'Barat'),
  Chinese: L('中華', '中餐', '中餐', 'चीनी', 'จีน', 'Tionghoa'),
  Vietnamese: L('ベトナム料理', '越南菜', '越南菜', 'वियतनामी', 'เวียดนาม', 'Vietnam'),
  Cafe: L('カフェ', '咖啡店', '咖啡店', 'कैफ़े', 'คาเฟ่', 'Kafe'),
  Bakery: L('ベーカリー', '烘焙', '烘焙', 'बेकरी', 'เบเกอรี่', 'Roti'),
  Mart: L('スーパー', '超市', '超市', 'मार्ट', 'มาร์ท', 'Mart'),
  Convenience: L('コンビニ', '便利店', '便利商店', 'किराना', 'ร้านสะดวกซื้อ', 'Minimarket'),
  Delivery: L('デリバリー', '外卖', '外送', 'डिलीवरी', 'เดลิเวอรี', 'Pengantaran'),
  'Group Buy': L('共同購入', '团购', '團購', 'ग्रुप बाय', 'ซื้อร่วม', 'Beli bersama'),
  Restaurant: L('レストラン', '餐厅', '餐廳', 'रेस्तरां', 'ร้านอาหาร', 'Restoran'),
  Apartment: L('マンション', '公寓', '公寓', 'अपार्टमेंट', 'อพาร์ตเมนต์', 'Apartemen'),
  Villa: L('ヴィラ', '别墅', '別墅', 'विला', 'วิลล่า', 'Villa'),
  'Detached House': L('戸建て', '独栋', '獨棟', 'अलग घर', 'บ้านเดี่ยว', 'Rumah mandiri'),
  Commercial: L('店舗', '商铺', '商鋪', 'दुकान', 'พาณิชย์', 'Komersial'),
  Office: L('オフィス', '办公室', '辦公室', 'ऑफिस', 'ออฟฟิศ', 'Kantor'),
  'Monthly Rent': L('月額賃貸', '月租', '月租', 'मासिक किराया', 'เช่ารายเดือน', 'Sewa bulanan'),
  Jeonse: L('チョンセ', '全税', '全稅', 'जोनसे', 'จอนเซ', 'Jeonse'),
  Sale: L('売買', '买卖', '買賣', 'बिक्री', 'ขาย', 'Jual'),
  'Appliance Rental': L('家電レンタル', '家电租赁', '家電租賃', 'उपकरण किराया', 'เช่าเครื่องใช้', 'Sewa elektronik'),
  'Lease Transfer': L('賃貸承継', '转租', '轉租', 'लीज़ ट्रांसफर', 'โอนสัญญาเช่า', 'Pengalihan sewa'),
  'Office Transfer': L('オフィス承継', '办公室转租', '辦公室轉租', 'ऑफिस ट्रांसफर', 'โอนออฟฟิศ', 'Pengalihan kantor'),
  'Long-term Rent': L('長期賃貸', '长租', '長租', 'लंबी अवधि किराया', 'เช่าระยะยาว', 'Sewa jangka panjang'),
  'Share House': L('シェアハウス', '合租', '合租', 'शेयर हाउस', 'แชร์เฮาส์', 'Share house'),
  Hotel: L('ホテル', '酒店', '飯店', 'होटल', 'โรงแรม', 'Hotel'),
  Resort: L('リゾート', '度假村', '度假村', 'रिसॉर्ट', 'รีสอร์ต', 'Resor'),
  'Pool Villa': L('プールヴィラ', '泳池别墅', '泳池別墅', 'पूल विला', 'พูลวิลล่า', 'Villa kolam'),
  Guesthouse: L('ゲストハウス', '民宿', '民宿', 'गेस्टहाउस', 'เกสต์เฮาส์', 'Guesthouse'),
  Homestay: L('ホームステイ', '寄宿家庭', '寄宿家庭', 'होमस्टे', 'โฮมสเตย์', 'Homestay'),
  'Short Stay': L('短期滞在', '短住', '短住', 'अल्प प्रवास', 'พักสั้น', 'Menginap singkat'),
  Pension: L('ペンション', '民宿旅馆', '民宿旅館', 'पेंशन', 'เพนชัน', 'Pension'),
  Cleaning: L('清掃', '保洁', '清潔', 'सफ़ाई', 'ทำความสะอาด', 'Kebersihan'),
  Moving: L('引越し', '搬家', '搬家', 'मूविंग', 'ย้ายบ้าน', 'Pindahan'),
  Repair: L('修理', '维修', '維修', 'मरम्मत', 'ซ่อม', 'Perbaikan'),
  Interior: L('インテリア', '室内装修', '室內裝修', 'इंटीरियर', 'อินทีเรียร์', 'Interior'),
  'AC Cleaning': L('エアコン清掃', '空调清洗', '冷氣清洗', 'एसी सफ़ाई', 'ล้างแอร์', 'Cuci AC'),
  'Curtain & Blind': L('カーテン・ブラインド', '窗帘百叶', '窗簾百葉', 'पर्दे', 'ม่านและมู่ลี่', 'Gorden & blind'),
  Flooring: L('床材', '地板', '地板', 'फ़र्श', 'พื้น', 'Lantai'),
  Tile: L('タイル', '瓷砖', '磁磚', 'टाइल', 'กระเบื้อง', 'Ubin'),
  Wallpaper: L('壁紙', '墙纸', '壁紙', 'वॉलपेपर', 'วอลล์เปเปอร์', 'Wallpaper'),
  'Furniture Assembly': L('家具組立', '家具组装', '家具組裝', 'फर्नीचर जोड़ना', 'ประกอบเฟอร์นิเจอร์', 'Rakit furnitur'),
  'Pest Control': L('害虫駆除', '除虫', '除蟲', 'कीट नियंत्रण', 'กำจัดแมลง', 'Hama'),
  Gardening: L('庭仕事', '园艺', '園藝', 'बागवानी', 'สวน', 'Taman'),
  'AC Service': L('エアコン修理', '空调维修', '冷氣維修', 'एसी सेवा', 'บริการแอร์', 'Servis AC'),
  'Single Tour': L('単品ツアー', '单次行程', '單次行程', 'सिंगल टूर', 'ทัวร์เดี่ยว', 'Tur satuan'),
  'Package Tour': L('パッケージ', '套餐游', '套裝遊', 'पैकेज टूर', 'ทัวร์แพ็กเกจ', 'Paket tur'),
  'Day Tour': L('日帰り', '一日游', '一日遊', 'डे टूर', 'ทัวร์วันเดียว', 'Tur harian'),
  Golf: L('ゴルフ', '高尔夫', '高爾夫', 'गोल्फ़', 'กอล์ฟ', 'Golf'),
  Activity: L('アクティビティ', '活动体验', '活動體驗', 'एक्टिविटी', 'กิจกรรม', 'Aktivitas'),
  Experience: L('体験', '体验', '體驗', 'अनुभव', 'ประสบการณ์', 'Pengalaman'),
  'Pickup & Drop': L('送迎', '接送', '接送', 'पिकअप ड्रॉप', 'รับส่ง', 'Jemput antar'),
  'Airport Pickup': L('空港送迎', '机场接送', '機場接送', 'एयरपोर्ट पिकअप', 'รับสนามบิน', 'Jemput bandara'),
  'Car Rental': L('レンタカー', '租车', '租車', 'कार किराया', 'เช่ารถ', 'Sewa mobil'),
  Cruise: L('クルーズ', '邮轮', '郵輪', 'क्रूज़', 'ครูซ', 'Kapal pesiar'),
  'Tour & Guide': L('ツアー・ガイド', '导游行程', '導遊行程', 'टूर और गाइड', 'ทัวร์และไกด์', 'Tur & pemandu'),
  'Visa Run': L('ビザラン', '签证跑', '簽證跑', 'वीज़ा रन', 'วิซ่ารัน', 'Visa run'),
  'Photo Snap': L('スナップ撮影', '快拍', '快拍', 'फ़ोटो स्नैप', 'ถ่ายรูป', 'Foto snap'),
  Flight: L('航空券', '机票', '機票', 'उड़ान', 'ตั๋วเครื่องบิน', 'Tiket pesawat'),
  English: L('英語', '英语', '英語', 'अंग्रेज़ी', 'อังกฤษ', 'Inggris'),
  Math: L('数学', '数学', '數學', 'गणित', 'คณิต', 'Matematika'),
  Music: L('音楽', '音乐', '音樂', 'संगीत', 'ดนตรี', 'Musik'),
  Art: L('美術', '美术', '美術', 'कला', 'ศิลปะ', 'Seni'),
  Sports: L('スポーツ', '体育', '體育', 'खेल', 'กีฬา', 'Olahraga'),
  Cooking: L('料理教室', '烹饪', '烹飪', 'खाना बनाना', 'ทำอาหาร', 'Memasak'),
  Online: L('オンライン', '线上', '線上', 'ऑनलाइन', 'ออนไลน์', 'Online'),
  Offline: L('オフライン', '线下', '線下', 'ऑफ़लाइन', 'ออฟไลน์', 'Offline'),
  '1-on-1': L('マンツーマン', '一对一', '一對一', '1-पर-1', 'ตัวต่อตัว', 'Satu lawan satu'),
  Group: L('グループ', '小组', '小組', 'ग्रुप', 'กลุ่ม', 'Grup'),
  Language: L('語学', '语言', '語言', 'भाषा', 'ภาษา', 'Bahasa'),
  Academy: L('塾・クラス', '补习班', '補習班', 'अकादमी', 'สถาบัน', 'Akademi'),
  'Arts & Sports': L('芸能・スポーツ', '艺体', '藝體', 'कला और खेल', 'ศิลปะและกีฬา', 'Seni & olahraga'),
  Consulting: L('受験相談', '升学咨询', '升學諮詢', 'परामर्श', 'ที่ปรึกษา', 'Konsultasi'),
  Certificate: L('資格', '证书', '證照', 'प्रमाणपत्र', 'ใบรับรอง', 'Sertifikat'),
  'Hair Salon': L('美容室', '美发', '美髮', 'हेयर सैलून', 'ร้านตัดผม', 'Salon rambut'),
  Barber: L('理容', '理发', '理髮', 'नाई', 'ร้านตัดผมชาย', 'Barber'),
  Nail: L('ネイル', '美甲', '美甲', 'नेल', 'เล็บ', 'Kuku'),
  Waxing: L('ワックス', '脱毛', '除毛', 'वैक्सिंग', 'แว็กซ์', 'Waxing'),
  Massage: L('マッサージ', '按摩', '按摩', 'मालिश', 'นวด', 'Pijat'),
  Spa: L('スパ', '水疗', '水療', 'स्पा', 'สปา', 'Spa'),
  Skincare: L('スキンケア', '皮肤护理', '皮膚保養', 'स्किनकेयर', 'สกินแคร์', 'Perawatan kulit'),
  Beauty: L('美容', '美容', '美容', 'ब्यूटी', 'บิวตี้', 'Kecantikan'),
  Gym: L('ジム', '健身房', '健身房', 'जिम', 'ยิม', 'Gym'),
  Fitness: L('フィットネス', '健身私教', '健身私教', 'फिटनेस', 'ฟิตเนส', 'Fitness'),
  'Internal Medicine': L('内科', '内科', '內科', 'आंतरिक चिकित्सा', 'อายุรกรรม', 'Penyakit dalam'),
  Dental: L('歯科', '牙科', '牙科', 'दंत', 'ทันตกรรม', 'Gigi'),
  Dermatology: L('皮膚科', '皮肤科', '皮膚科', 'त्वचा', 'ผิวหนัง', 'Kulit'),
  'Plastic Surgery': L('美容外科', '整形', '整形', 'प्लास्टिक सर्जरी', 'ศัลยกรรม', 'Bedah plastik'),
  'Oriental Medicine': L('韓方', '韩医', '韓醫', 'पूर्वी चिकित्सा', 'แพทย์แผนตะวันออก', 'Pengobatan timur'),
  Pharmacy: L('薬局', '药店', '藥局', 'फार्मेसी', 'ร้านยา', 'Apotek'),
  Hospital: L('病院', '医院', '醫院', 'अस्पताल', 'โรงพยาบาล', 'Rumah sakit'),
  'Mental Health': L('心の相談', '心理咨询', '心理諮詢', 'मानसिक स्वास्थ्य', 'สุขภาพจิต', 'Kesehatan mental'),
  Taxi: L('タクシー', '出租车', '計程車', 'टैक्सी', 'แท็กซี่', 'Taksi'),
  'Moto Taxi': L('バイクタクシー', '摩的', '機車計程車', 'मोटर टैक्सी', 'วินมอเตอร์ไซค์', 'Ojek'),
  Courier: L('宅配', '货运', '貨運', 'कूरियर', 'ส่งของ', 'Kurir'),
  'Motorbike Rental': L('バイクレンタル', '摩托租赁', '機車租賃', 'बाइक किराया', 'เช่ามอเตอร์ไซค์', 'Sewa motor'),
  'Bicycle Rental': L('レンタサイクル', '自行车租赁', '單車租賃', 'साइकिल किराया', 'เช่าจักรยาน', 'Sewa sepeda'),
  Shuttle: L('シャトル', '班车', '接駁', 'शटल', 'รถรับส่ง', 'Shuttle'),
  'Bus & Van': L('バス・バン', '包车', '包車', 'बस और वैन', 'รถบัสและแวน', 'Bus & van'),
  'Motorbike Trade': L('バイク売買', '摩托买卖', '機車買賣', 'बाइक खरीद-बिक्री', 'ซื้อขายมอเตอร์ไซค์', 'Jual-beli motor'),
  'Car Trade': L('車売買', '汽车买卖', '汽車買賣', 'कार खरीद-बिक्री', 'ซื้อขายรถ', 'Jual-beli mobil'),
  'SIM & eSIM': L('SIM・eSIM', 'SIM和eSIM', 'SIM與eSIM', 'सिम और ईसिम', 'ซิมและ eSIM', 'SIM & eSIM'),
  'Phone Activation': L('回線開通', '开户', '開通', 'फ़ोन एक्टिवेशन', 'เปิดเบอร์', 'Aktivasi HP'),
  'Internet & Wifi Install': L('ネット設置', '宽带安装', '寬頻安裝', 'इंटरनेट इंस्टॉल', 'ติดตั้งเน็ต', 'Pasang internet'),
  'Pocket Wifi': L('ポケットWiFi', '随身WiFi', '隨身WiFi', 'पॉकेट वाईफ़ाई', 'พ็อกเก็ตไวไฟ', 'Wifi saku'),
  'Phone Shop & Used Phone': L('スマホ店・中古', '手机店', '手機店', 'फ़ोन दुकान', 'ร้านมือถือ', 'Toko HP'),
  'Carrier Agency': L('キャリア代理店', '运营商代理', '電信代辦', 'कैरियर एजेंसी', 'ตัวแทนเครือข่าย', 'Agen operator'),
  'Repair & After-service': L('修理・保証', '维修售后', '維修保固', 'मरम्मत और सेवा', 'ซ่อมและบริการ', 'Servis purna jual'),
  'Korea Remittance': L('韓国送金', '汇韩国', '匯韓國', 'कोरिया रेमिटेंस', 'โอนเกาหลี', 'Kirim ke Korea'),
  'Vietnam Remittance': L('ベトナム送金', '汇越南', '匯越南', 'वियतनाम रेमिटेंस', 'โอนเวียดนาม', 'Kirim ke Vietnam'),
  Exchange: L('両替', '换汇', '換匯', 'एक्सचेंज', 'แลกเงิน', 'Tukar uang'),
  Loan: L('ローン', '贷款', '貸款', 'ऋण', 'สินเชื่อ', 'Pinjaman'),
  Insurance: L('保険', '保险', '保險', 'बीमा', 'ประกัน', 'Asuransi'),
  Remittance: L('海外送金', '跨境汇款', '跨境匯款', 'रेमिटेंस', 'โอนเงินต่างประเทศ', 'Remitansi'),
  'Wedding Photo': L('ウェディング撮影', '婚纱照', '婚紗照', 'वेडिंग फ़ोटो', 'ถ่ายพรีเวดดิ้ง', 'Foto pernikahan'),
  'Wedding Dress': L('ドレス', '婚纱', '婚紗', 'वेडिंग ड्रेस', 'ชุดแต่งงาน', 'Gaun pengantin'),
  Makeup: L('メイク', '化妆', '化妝', 'मेकअप', 'เมกอัป', 'Makeup'),
  'Studio Package': L('スタジオパック', '影楼套餐', '影樓套餐', 'स्टूडियो पैकेज', 'แพ็กเกจสตูดิโอ', 'Paket studio'),
  Honeymoon: L('ハネムーン', '蜜月', '蜜月', 'हनीमून', 'ฮันนีมูน', 'Bulan madu'),
  'First Birthday': L('一歳祝い', '周岁宴', '周歲宴', 'पहला जन्मदिन', 'วันเกิดครบรอบปี', 'Ulang tahun pertama'),
  'Birthday Party': L('誕生日パーティー', '生日派对', '生日派對', 'जन्मदिन पार्टी', 'ปาร์ตี้วันเกิด', 'Pesta ulang tahun'),
  'Corporate Event': L('企業イベント', '企业活动', '企業活動', 'कॉर्पोरेट इवेंट', 'งานองค์กร', 'Acara perusahaan'),
  Planner: L('プランナー', '策划', '企劃', 'प्लानर', 'แพลนเนอร์', 'Perencana'),
  Studio: L('スタジオ', '影楼', '影樓', 'स्टूडियो', 'สตูดิโอ', 'Studio'),
  Party: L('パーティー', '派对策划', '派對企劃', 'पार्टी', 'ปาร์ตี้', 'Pesta'),
  Catering: L('ケータリング', '餐饮外包', '外燴', 'केटरिंग', 'จัดเลี้ยง', 'Katering'),
  MC: L('司会', '司仪', '司儀', 'एमसी', 'พิธีกร', 'MC'),
  Flowers: L('花・花輪', '鲜花花圈', '鮮花花圈', 'फूल', 'ดอกไม้', 'Bunga'),
  Veterinary: L('動物病院', '宠物医院', '寵物醫院', 'पशु चिकित्सक', 'สัตวแพทย์', 'Dokter hewan'),
  Grooming: L('トリミング', '美容', '美容', 'ग्रूमिंग', 'กรูมมิ่ง', 'Grooming'),
  'Pet Hotel': L('ペットホテル', '宠物寄养', '寵物寄養', 'पेट होटल', 'โรงแรมสัตว์เลี้ยง', 'Hotel hewan'),
  Training: L('しつけ', '训练', '訓練', 'ट्रेनिंग', 'ฝึก', 'Pelatihan'),
  Supplies: L('用品', '用品', '用品', 'सामान', 'อุปกรณ์', 'Perlengkapan'),
  Adoption: L('里親', '领养', '領養', 'गोद लेना', 'รับเลี้ยง', 'Adopsi'),
  'Pet Food Delivery': L('フード配達', '宠物粮配送', '寵物糧配送', 'पेट फ़ूड डिलीवरी', 'ส่งอาหารสัตว์', 'Antar pakan'),
  'Pet Shop': L('ペットショップ', '宠物店', '寵物店', 'पेट शॉप', 'เพ็ทช็อป', 'Pet shop'),
  Photographer: L('写真家', '摄影师', '攝影師', 'फ़ोटोग्राफ़र', 'ช่างภาพ', 'Fotografer'),
  'Video Production': L('映像制作', '影视制作', '影視製作', 'वीडियो प्रोडक्शन', 'โปรดักชันวิดีโอ', 'Produksi video'),
  'SNS Marketing': L('SNSマーケ', '社媒营销', '社群行銷', 'एसएनएस मार्केटिंग', 'การตลาดโซเชียล', 'Pemasaran SNS'),
  'Ad Agency': L('広告代理', '广告代理', '廣告代理', 'विज्ञापन एजेंसी', 'เอเจนซี่โฆษณา', 'Agensi iklan'),
  YouTube: L('YouTube', 'YouTube', 'YouTube', 'YouTube', 'YouTube', 'YouTube'),
  Instagram: L('Instagram', 'Instagram', 'Instagram', 'Instagram', 'Instagram', 'Instagram'),
  Marketing: L('コンテンツマーケ', '内容营销', '內容行銷', 'मार्केटिंग', 'การตลาด', 'Pemasaran'),
  SNS: L('SNS運用', '社媒运营', '社群經營', 'एसएनएस', 'โซเชียล', 'SNS'),
  Babysitter: L('ベビーシッター', '保姆', '保母', 'बेबीसिट्टर', 'พี่เลี้ยงเด็ก', 'Pengasuh'),
  'Postpartum Care': L('産後ケア', '月子护理', '月子護理', 'प्रसवोत्तर देखभाल', 'ดูแลหลังคลอด', 'Perawatan pascapersalinan'),
  'Daycare Info': L('保育園情報', '托儿所信息', '托兒所資訊', 'डेकेयर जानकारी', 'ข้อมูลเนิร์สเซอรี่', 'Info penitipan'),
  'Baby Products': L('ベビー用品', '婴儿用品', '嬰兒用品', 'शिशु उत्पाद', 'ของเด็ก', 'Perlengkapan bayi'),
  'Child Education': L('幼児教育', '儿童教育', '兒童教育', 'बाल शिक्षा', 'การศึกษาเด็ก', 'Pendidikan anak'),
  'Kids Cafe': L('キッズカフェ', '亲子咖啡', '親子咖啡', 'किड्स कैफ़े', 'คิดส์คาเฟ่', 'Kafe anak'),
  Pediatrics: L('小児科', '儿科', '小兒科', 'बाल रोग', 'กุมารเวช', 'Anak'),
  'After School': L('学童保育', '课后托管', '課後托管', 'आफ्टर स्कूल', 'หลังเลิกเรียน', 'Setelah sekolah'),
  'Elder Care': L('高齢者ケア', '老人护理', '老人護理', 'वृद्ध देखभाल', 'ดูแลผู้สูงอายุ', 'Perawatan lansia'),
  Housekeeping: L('家事代行', '家政', '家政', 'हाउसकीपिंग', 'แม่บ้าน', 'PR rumah tangga'),
  Nursing: L('介護', '看护', '看護', 'नर्सिंग', 'พยาบาล', 'Perawat'),
  Hiring: L('求人', '招聘', '徵才', 'भर्ती', 'รับสมัคร', 'Rekrut'),
  'Job Seeking': L('求職', '求职', '求職', 'नौकरी खोज', 'หางาน', 'Cari kerja'),
  Freelance: L('フリーランス', '自由职业', '自由工作', 'फ़्रीलांस', 'ฟรีแลนซ์', 'Freelance'),
  Intern: L('インターン', '实习', '實習', 'इंटर्न', 'ฝึกงาน', 'Magang'),
  Visa: L('ビザ', '签证', '簽證', 'वीज़ा', 'วีซ่า', 'Visa'),
  'Legal Consult': L('法律相談', '法律咨询', '法律諮詢', 'कानूनी सलाह', 'ที่ปรึกษากฎหมาย', 'Konsultasi hukum'),
  'Tax & Accounting': L('税務・会計', '税务会计', '稅務會計', 'कर और अकाउंटिंग', 'ภาษีและบัญชี', 'Pajak & akuntansi'),
  'Company Setup': L('会社設立', '公司注册', '公司設立', 'कंपनी सेटअप', 'ตั้งบริษัท', 'Pendirian PT'),
  'Admin Agency': L('行政代行', '行政代办', '行政代辦', 'एडमिन एजेंसी', 'ตัวแทนราชการ', 'Jasa administrasi'),
  Translation: L('翻訳', '翻译', '翻譯', 'अनुवाद', 'แปล', 'Terjemahan'),
  Interpretation: L('通訳', '口译', '口譯', 'दुभाषिया', 'ล่าม', 'Juru bahasa'),
  Notarization: L('公証', '公证', '公證', 'नोटरी', 'โนตารี', 'Notaris'),
  'Labor Consult': L('労務相談', '劳务咨询', '勞務諮詢', 'श्रम सलाह', 'ที่ปรึกษาแรงงาน', 'Konsultasi ketenagakerjaan'),
};

export function hubSubExtraFromEn(labelEn) {
  return HUB_SUB_LABEL_BY_EN[labelEn] || {
    ja: labelEn, 'zh-CN': labelEn, 'zh-TW': labelEn, hi: labelEn, th: labelEn, id: labelEn,
  };
}
